import React from "react";

import { default as ReactSelect } from "react-select";
import { components } from "react-select";
// import { capitalizeFirstLetter } from "../../../store/utility";

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

class ReactCustomSelect extends React.Component {
  state = {
    optionSelected: [],
    intitialSetup: false,
  };

  componentDidUpdate = () => {
    // console.log("ComponentDidUpdate");
    // console.log(`Gender`, this.props.optionSelected);
    if (this.state.optionSelected) {
      let stateOptionValues = [];
      this.state.optionSelected.map((obj) => {
        stateOptionValues.push(obj.value);
      });
      if (
        JSON.stringify(this.props.optionSelected) !=
        JSON.stringify(stateOptionValues)
      ) {
        if (
          this.props.optionSelected &&
          this.props.optionSelected.length > stateOptionValues.length &&
          !this.state.intitialSetup
        ) {
          this.setState({
            optionSelected: this.parseValuesToOptions(),
            intitialSetup: true,
          });
        } else {
          this.props.handleChange(stateOptionValues);
        }
      }
    }
  };

  parseValuesToOptions = () => {
    let optionSelected = this.props.optionSelected;
    let parsedOptions = [];
    if (optionSelected) {
      optionSelected.map((optionValue) => {
        parsedOptions.push({
          label: optionValue.toLowerCase(),
          value: optionValue,
        });
      });
    }
    console.log("ParsedOptions", parsedOptions);
    return parsedOptions;
  };

  // componentDidMount = () => {
  //   console.log("ComponentDidMount");
  //   let optionSelected = this.props.optionSelected;
  //   console.log(optionSelected);
  //   if (optionSelected) {
  //     let parsedOptions = [];
  //     optionSelected.map((optionValue) => {
  //       parsedOptions.push({
  //         label: optionValue.toLowerCase(),
  //         value: optionValue,
  //       });
  //     });
  //     // console.log(`Parsed Options`, parsedOptions);
  //     this.setState({ optionSelected: parsedOptions });
  //   }
  // };

  handleSelect = (selected) => {
    this.setState({
      optionSelected: selected,
    });
  };
  colourOptions = [
    { value: "men", label: "Men" },
    { value: "women", label: "Women" },
  ];

  render() {
    return (
      <span
        className="d-inline-block "
        style={{ width: "100%" }}
        data-toggle="popover"
        data-trigger="focus"
        data-content="Please selecet account(s)"
      >
        <ReactSelect
          options={this.colourOptions}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          components={{
            Option,
          }}
          onChange={this.handleSelect}
          allowSelectAll={true}
          value={this.state.optionSelected}
        />
      </span>
    );
  }
}

export default ReactCustomSelect;
